<article
  class="card"
  [class.reverse]="reverse()"
>
  <ng-container
    *nodaResponsiveIf="['(max-width: ' + mediaMaxWidth() + 'px)']"
    [ngTemplateOutlet]="header"
  />
  <section class="card__description">
    <ng-container
      *nodaResponsiveIf="['(min-width: ' + mediaMinWidth() + 'px)']"
      [ngTemplateOutlet]="header"
    />
    <div class="card__content">
      <ng-content select="[content]" />
    </div>
    <div class="card__action">
      <ng-content select="[button]" />
    </div>
  </section>
  <section class="card__section">
    <ng-content select="[sub-content]" />
  </section>
</article>
<ng-template #header>
  <header class="card__heading">
    <ng-content select="[subtitle]" />
    <ng-content select="[title]" />
  </header>
</ng-template>
